import { listWeb } from '../../api/home/home'
export function processTree(tree, callback, children='children') {
    if (!Array.isArray(tree) || tree.length === 0) {
        return;
    }

    tree.forEach(node => {
        // 处理当前节点
        callback(node);

        // 如果当前节点有子节点，递归处理子节点
        if (node[children] && Array.isArray(node[children])) {
            processTree(node[children], callback);
        }
    });
}
// tree 需要遍历的树状结构
// name 需要对比的数值
// parentNode 父级节点
// 需要遍历对比的节点名称nodeNeedId
export function findNode(tree, name, parentNode = null, nodeNeedId = 'name') {
    // 遍历树的当前层级
    for (let node of tree) {
        // 检查当前节点的名字是否匹配
        if (node[nodeNeedId] === name) {
            // 返回包含当前节点、父节点和子节点的对象
            return {
                currentNode: node,
                parentNode: parentNode,
                children: node.children || [] // 如果没有子节点，返回空数组
            };
        }
 
        // 如果当前节点有子节点，递归查找
        if (node.children && Array.isArray(node.children)) {
            const result = findNode(node.children, name, node, nodeNeedId); // 传递当前节点作为父节点
            if (result) {
                return result;
            }
        }
    }
 
    // 如果没有找到匹配的节点，返回 null
    return null;
}

// 给内层节点添加首层节点id
// function addRootIdToLeaves(nodes, rootId) {
//     return nodes.map(node => {
//         let newNode = { ...node };
//         if (newNode.children && newNode.children.length > 0) {
//             newNode.children = addRootIdToLeaves(newNode.children, newNode.menuId);
//         } else {
//             // 这是最内层的节点，添加根节点的ID
//             newNode.rootId = rootId;
//         }
//         return newNode;
//     });
// }
 
// export function processTreeData(tree) {
//     return tree.map(rootNode => {
//         let newNode = { ...rootNode };
//         newNode.children = addRootIdToLeaves(newNode.children, rootNode.menuId);
//         return newNode;
//     });
// }

export function processTreeData(tree, rootId = '') {
    tree.forEach(f => {
        f.rootId = rootId || f.menuId
        if (f.children && f.children.length) {
            processTreeData(f.children, rootId || f.menuId)
        }
    })
}
 

export const navObjType = {
    '师资团队': '1',
    '名特教师': '2',
    '附中年度人物': '3',
    'template-3': 'template-3', // template 名师风采1新闻列表3新闻列表图片4时间轴8简介9新闻资讯模板11
    'template-4': 'template-4'
}
export const colorType = {
    2: '#E4150C',
    1: '#0B49A3'
}

// export function imgTagAddStyle(htmlstr='', style){
//     if (!htmlstr) return
//     //正则匹配不含style="" 或 style='' 的img标签
//     var regex1 = new RegExp("(i?)(\<img)(?!(.*?style=['\"](.*)['\"])[^\>]+\>)","gmi");
//     //给不含style="" 或 style='' 的img标签加上style=""
//     htmlstr = htmlstr.replace(regex1, "$2 style=\"\"$3");
//     //正则匹配含有style的img标签
//     var regex2 = new RegExp("(i?)(\<img.*?style=['\"])([^\>]+\>)","gmi");
//     //在img标签的style里面增加css样式(这里增加的样式：display:block;max-width:100%;height:auto;border:5px solid red;)
//     htmlstr = htmlstr.replace(regex2, "$2" + style + "$3");
//     return htmlstr;
// }

export function imgTagAddStyle(htmlstr = '', style) {
    if (!htmlstr) return htmlstr;
    // 使用正则表达式匹配所有 img 标签，并根据需要添加或修改 style 属性
    return htmlstr.replace(/<img\b([^>]*)>/gi, function(match, attrs) {
        // 检查是否已经存在 style 属性，并构造新的 style 属性值
        var hasStyle = /style=["']/.test(attrs);
        var newStyleAttr = hasStyle ? 'style="' + (attrs.match(/style=["']([^"']*)["']/)[1] + ';' + style) + '"' : 'style="' + style.trim() + '"';
        // 返回更新后的 img 标签，其中 style 属性已被添加或修改
        return '<img ' + newStyleAttr + ' ' + attrs.replace(/style=["'].*?["']/i, '') + '>';
    });
}

function findNodeWithAncestors(tree, targetName, hasAll) {
    function traverse(node, path, i) {
        // console.log(node, path, '--0-0-0', node.menuName);
        // Add current node to the path
        if(hasAll) {
            path.push({ menuIdn: node.menuId, ...node })
        } else {
            path.push({ menuIdn: node.menuId, menuName: node.menuName });
        }

        // Check if the current node is the target
        if (node.menuName === targetName) {
            return path;
        }
        

        // Traverse children
        for (const child of node.children || []) {
            const result = traverse(child, path.slice()); // Use slice to avoid mutation
            if (result) {
                return result;
            }
        }

        // If not found, return null and backtrack
        return null;
    }

    // Start the search from the root
    // return traverse(tree[0], []);
    for (const item of tree || []) {
        const result = traverse(item, [])
        if (result) return result
    }
    return null
}

// 获取本地存储的点击菜单数据
export function featchClickMenuDataFromLocal(type = 'menuName', findType = null) {
    return new Promise((resolve, reject) => {
        const name = localStorage.getItem('choiceMenuName')
        // 需要一级菜单,本地存储的是二级菜单---从接口重新获取
        try {
            listWeb().then(res => {
                const list = res.data || []
                if (findType.includes('picture')) {
                    const findData = findNodeWithAncestors(JSON.parse(JSON.stringify(list)), name, true)
                    return resolve(findData)
                }
                return resolve(findData)
            })
        } catch (err) {
            throw '接口调用失败'
        }
        
        
    })
    
}

/**
 * @function 回到页面顶部
 * @description 挂载到全局通过this.$returnTopPage调用
 * ***/
export const  returnToTheTopOfThePage = () => {
    document.documentElement.scrollTop = 0;
    window.pageYOffset = 0; // 兼容ios
    document.body.scrollTop = 0; // 兼容低版本ie
}


// WEBPACK FOOTER //
// ./src/utils/common.js